import {
	createStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// import enumerations.
import {
	BreakpointWidth,
} from '@app/enumerations';

const styles = (theme: Theme) => {
	return createStyles({
		newBusinessApplicationSummary_container: {
			display: 'flex',
			flexDirection: 'column',
		},
		newBusinessApplicationSummary_containerContent: {
			display: 'flex',
			flexDirection: 'column',
			border: `2px solid ${theme.palette.grey[400]}`,
			borderRadius: theme.shape.borderRadius,
		},
		newBusinessApplicationSummary_applicationInfoContainer: {
			margin: theme.spacing(2, 2, 1, 2),
		},
		newBusinessApplicationSummary_applicationInfoHeader: {
			display: 'flex',
			padding: theme.spacing(1),
			justifyContent: 'space-between',
			alignItems: 'center',
		},
		newBusinessApplicationSummary_applicationHeaderLabelContainer: {
			display: 'flex',
		},
		newBusinessApplicationSummary_applicationInfoHeaderFieldLabel: {
			color: theme.palette.info.main,
			fontSize: theme.typography.body1.fontSize,
			fontWeight: theme.typography.fontWeightBold as any,
			marginRight: theme.spacing(1),
		},
		newBusinessApplicationSummary_applicationInfoHeaderValueLabel: {
			color: theme.palette.info.main,
			fontSize: theme.typography.body1.fontSize,
		},
		newBusinessApplicationSummary_applicationInfoHeaderExpandButton: {
			color: theme.palette.info.main,
			padding: theme.spacing(0),
		},
		newBusinessApplicationSummary_applicationInfoRow: {
			display: 'flex',
			padding: theme.spacing(1),
			alignItems: 'center',
		},
		newBusinessApplicationSummary_applicationInfoRowFieldLabel: {
			color: theme.palette.info.main,
			fontWeight: theme.typography.fontWeightBold as any,
			marginRight: theme.spacing(1),
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				fontSize: theme.typography.body2.fontSize,
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				fontSize: theme.typography.caption.fontSize,
			},
		},
		newBusinessApplicationSummary_applicationInfoRowValueLabel: {
			color: theme.palette.info.main,
			marginRight: theme.spacing(1),
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				fontSize: theme.typography.body2.fontSize,
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				fontSize: theme.typography.caption.fontSize,
			},
		},
		newBusinessApplicationSummary_applicationInfoEditButton: {
			color: theme.palette.info.main,
			padding: theme.spacing(0),
		},
		newBusinessApplicationSummary_applicationInfoEditIcon: {
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				fontSize: theme.typography.h6.fontSize,
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				fontSize: theme.typography.fontSize,
			},
		},
		newBusinessApplicationSummary_applicationInfoParentAgencyOverridenLabel: {
			color: theme.palette.error.main,
			marginLeft: theme.spacing(1),
		},
		newBusinessApplicationSummary_totalCostContainer: {
			margin: theme.spacing(1, 2, 1, 2),
			display: 'flex',
			flexDirection: 'column',
			padding: theme.spacing(2),
		},
		newBusinessApplicationSummary_totalCostLabel: {
			display: 'flex',
			justifyContent: 'center',
			fontSize: theme.typography.h6.fontSize,
			padding: theme.spacing(1, 0),
			color: theme.palette.info.main,
		},
		newBusinessApplicationSummary_totalCostValue: {
			display: 'flex',
			justifyContent: 'center',
			fontSize: theme.typography.h3.fontSize,
			color: theme.palette.primary.main,
			borderBottom: `2px solid ${theme.palette.grey[400]}`,
			padding: theme.spacing(1, 0),
		},
		newBusinessApplicationSummary_totalCostExpandButtonWrapper: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			marginLeft: theme.spacing(1),
		},
		newBusinessApplicationSummary_totalCostExpandButton: {
			padding: theme.spacing(0),
			color: theme.palette.info.main,
		},
		newBusinessApplicationSummary_totalCostExpandButtonIcon: {
			fontSize: theme.typography.h5.fontSize,
		},
		newBusinessApplicationSummary_totalCostBreakdown: {
			display: 'flex',
			flexDirection: 'column',
			margin: theme.spacing(1, 0, 0, 0),
		},
		newBusinessApplicationSummary_totalCostBreakdownRow: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			margin: theme.spacing(1, 0),
		},
		newBusinessApplicationSummary_totalCostBreakdownRowField: {
			color: theme.palette.info.main,
			fontWeight: theme.typography.fontWeightBold as any,
			marginRight: theme.spacing(1),
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				fontSize: theme.typography.body2.fontSize,
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				fontSize: theme.typography.caption.fontSize,
			},
		},
		newBusinessApplicationSummary_totalCostBreakdownRowValue: {
			color: theme.palette.info.main,
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				fontSize: theme.typography.body2.fontSize,
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				fontSize: theme.typography.caption.fontSize,
			},
		},
		newBusinessApplicationSummary_totalCostErrorsBody: {
			display: 'flex',
		},
		newBusinessApplicationSummary_totalCostErrorsFooter: {
			display: 'flex',
			justifyContent: 'flex-end',
			marginTop: theme.spacing(2),
		},
		newBusinessApplicationSummary_totalCostErrorIcon: {
			color: theme.palette.warning.main,
			fontSize: theme.typography.h3.fontSize,
		},
		newBusinessApplicationSummary_totalCostErrorIconWrapper: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			marginRight: theme.spacing(2),
		},
		newBusinessApplicationSummary_totalCostErrorMessage: {
			color: theme.palette.warning.main,
			fontWeight: theme.typography.fontWeightLight as any,
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				fontSize: theme.typography.body2.fontSize,
			},
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				fontSize: theme.typography.caption.fontSize,
			},
		},
		newBusinessApplicationSummary_proceedWithPaymentButtonWrapper: {
			padding: theme.spacing(1, 2),
			display: 'flex',
			flexDirection: 'column',
		},
		newBusinessApplicationSummary_proceedWithPaymentButtonHelperTextWrapper: {
			display: 'flex',
			flexDirection: 'row',
			marginTop: theme.spacing(1),
		},
		newBusinessApplicationSummary_proceedWithPaymentButtonHelperText: {
			color: theme.palette.info.main,
		},
		newBusinessApplicationSummary_proceedWithPaymentButtonHelperTextIcon: {
			fontSize: theme.typography.subtitle1.fontSize,
			alignSelf: 'center',
			marginLeft: theme.spacing(.5),
			color: theme.palette.info.main,
		},
	});
}

export default styles;
